import { FC, PropsWithChildren, useState } from "react";
import { CardContext } from "./context";

const CardProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (value: boolean) => {
    setIsFocused(value);
  };

  const context = {
    isFocused,
    handleFocus
  };

  return (
    <CardContext.Provider value={context}>{children}</CardContext.Provider>
  );
};

export default CardProvider;
